const isDisableUserDelete = (row, user) => {
  return row.id === user.id;
};

export { isDisableUserDelete };
